export function setDisableNavigation(state, value) {
  state.disableNavigation = value;
}

export function setBudgetComparisonView(state, value) {
  state.budgetComparisonView = value;
}

export function setBudgetLeaseTypeView(state, value) {
  state.budgetLeaseTypeView = value;
}

export function setShowFinanceCalculation(state, value) {
  state.showFinanceCalculation = value;
}
